import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { uniq, isEmpty, isNil } from 'ramda';
import { Link } from 'react-router-dom';

// store
import { storeGet, useStoreValue } from '../../../../store';

// api
import BandoService from '../../../../service/bando-service';
import PreferredBandoService from '../../../../service/preferred-bando-service';

// tools
import set404FromErrorResponse from '../../../../helpers/set404FromErrorResponse';

// components
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import ProperBandoLabel from '../../../../components/ProperBandoLabel';

import translationStrings from '../../../../translationStringsForComponents';
import CompanyDocumentsService from '../../../../service/company-documents-service';


const ListCompaniesForAdminTable = () => {
    const chosenCompanyId = useStoreValue('chosenCompanyId');
    const [items, setItems] = useState(null);
    const [filters, setFilters] = useState(null);
    const [loading, setLoading] = useState(false);
    const [, setStatuses] = useState([]);

    useEffect(() => {
        setLoading(true);
        CompanyDocumentsService.getCompanyDocumentsGrouped(getCallback, errGetCallbacks);
    }, []);

    const getCallback = (data) => {
        if (data.status === 'SUCCESS') {
            const { totalActiveCall, companyDocument } = data.data;
            setItems(getFormattedData(companyDocument));
            setStatuses(uniq(companyDocument.map(o => o.status)))
            initFilters();
        }
        setLoading(false);
    }

    const errGetCallbacks = (data) => {
        set404FromErrorResponse(data);
        setLoading(false);
    }

    const getFormattedData = (data) => {
        return [...(data || [])].map((d) => {
            d.uploadedDate = new Date(d.uploadedDate);

            return d;
        });
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            companyName: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            userName: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            uploadedDate: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
            },
            status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
        });
    };

    const renderHeader = () => {
        return (
            <div className="appTableHeader">
                <Button type="button" icon="pi pi-filter-slash" label={__('Pulisci', 'htr')} outlined
                        onClick={clearFilter}/>
            </div>
        );
    };

    const dateStartBodyTemplate = (rowData) => {
        return formatDate(rowData.uploadedDate);
    };

    const progressTemplate = (rowData) => {
        return `${rowData.documentRecieved} / ${rowData.totalRequiredDocument}`;
    };

    const esgBodyTemplate = (rowData) => {
        return rowData.esgCompleted
            ? <Tag value={__('Completo', 'htr')} severity="success"/>
            : <Tag value={__('Da completare', 'htr')} severity="warning"/>;
    };

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)}
                         dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999"/>;
    };

    const statusBodyTemplate = (rowData) => {
        return <ProperBandoLabel status={rowData.status}/>;
    };

    const actionsBodyTemplate = (rowData) => {
        return <div className="appPageSection__tableActions">
            <Link to={`/moduli/${rowData.id}`}>
                <Button severity="info" label={__('Partecipa', 'htr')} icon="pi pi-arrow-right" size="small"
                        iconPos="right"/>
            </Link></div>
    }

    const header = renderHeader();

    return (
        <div className="appPageSection__table">
            <DataTable value={items} paginator showGridlines rows={5} loading={loading} dataKey="companyId"
                       filters={filters} stripedRows removableSort
                       header={header}
                       emptyMessage={translationStrings.emptyMessage}
                       onFilter={(e) => setFilters(e.filters)}>
                <Column field="companyName" header={__('Fornitore', 'htr')}
                        filter sortable
                        filterPlaceholder={__('Cerca il nome', 'htr')}
                        style={{ minWidth: '8rem' }}/>
                <Column field="userName" header={__('Registrato Da', 'htr')}
                        filter sortable
                        filterPlaceholder={__('Cerca il nome', 'htr')}
                        style={{ minWidth: '8rem' }}/>
                <Column header={__('Data registrazione', 'htr')} filterField="uploadedDate" dataType="date"
                        style={{ minWidth: '8rem' }}
                        body={dateStartBodyTemplate} filter filterElement={dateFilterTemplate}/>
                <Column header={__('Documenti ricevuti', 'htr')}
                        style={{ minWidth: '8rem' }}
                        body={progressTemplate}/>
                <Column header={__('Questionario ESG', 'htr')}
                        style={{ minWidth: '8rem' }}
                        body={esgBodyTemplate}/>
                <Column field="status" header={__('Stato', 'htr')}
                        style={{ minWidth: '7rem' }} body={statusBodyTemplate} />
                {/*{!isEmpty(chosenCompanyId) && chosenCompanyId !== 0
                    ? <Column header={__('Azioni', 'htr')}
                        body={actionsBodyTemplate}/> : null}*/}
            </DataTable>
        </div>
    )
}

export default ListCompaniesForAdminTable;